"use client"

import { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { motion } from "framer-motion"
import { Box, Container, useMediaQuery, useTheme } from "@mui/material"
import { useUIContext } from "../contexts/UIContext"
import Header from "../components/layout/Header"
import Sidebar from "../components/layout/Sidebar"
import ErrorBoundary from "../components/common/ErrorBoundary"

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: -20,
  },
}

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.4,
}

const MainLayout = () => {
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const { isSidebarOpen, toggleSidebar } = useUIContext()

  // Close sidebar on mobile when navigating
  useEffect(() => {
    if (isMobile) {
      toggleSidebar(false)
    }
  }, [location.pathname, isMobile, toggleSidebar])

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f9fafb" }}>
      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          transition: "margin 0.3s ease",
          ml: { xs: 0, sm: isSidebarOpen ? "250px" : "70px" },
          width: { xs: "100%", sm: `calc(100% - ${isSidebarOpen ? 250 : 70}px)` },
        }}
      >
        <Header />

        <Container maxWidth="xl" sx={{ mt: 3, mb: 5 }}>
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
          >
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </motion.div>
        </Container>
      </Box>
    </Box>
  )
}

export default MainLayout

